<div class="audio-control-container">
  <div class="menu-row">
    <div class="icon-label">
      <mat-icon>{{ muted ? 'volume_off' : 'volume_up' }}</mat-icon>
      <span>{{ 'liveEvents.gamification.backgroundMusic' | translate }}</span>
    </div>
    <qa-form-field-toggle
      [checked]="!muted"
      (valueChanged)="toggleMute()"
    ></qa-form-field-toggle>
  </div>

  <div class="volume-control-section">
    <div class="slider-container">
      <span class="label">{{ 'common.label.volume' | translate }}</span>
      <mat-slider step="0.05" min="0" max="1" color="primary">
        <input
          matSliderThumb
          [value]="volume"
          (input)="onVolumeChange($event)"
        />
      </mat-slider>
      <span class="percentage"
        >{{ (muted ? 0 : volume * 100) | number : '1.0-0' }} %</span
      >
    </div>
  </div>
</div>
